var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBacklink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_430_766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8006 12.5599C15.004 12.7889 15.252 12.974 15.5295 13.1038C15.8069 13.2335 16.1079 13.3053 16.4141 13.3147C16.7202 13.324 17.0251 13.2708 17.3099 13.1582C17.5947 13.0456 17.8536 12.8761 18.0706 12.6599L22.5206 8.20992C23.1508 7.57817 23.5047 6.72226 23.5047 5.82992C23.5047 4.93759 23.1508 4.08168 22.5206 3.44992L20.5206 1.44992C19.8889 0.819729 19.033 0.46582 18.1406 0.46582C17.2483 0.46582 16.3924 0.819729 15.7606 1.44992L11.3406 5.92992C11.1248 6.14607 10.9554 6.40409 10.8429 6.68812C10.7304 6.97215 10.6772 7.27618 10.6866 7.58152C10.696 7.88686 10.7677 8.18706 10.8974 8.46366C11.027 8.74026 11.2119 8.98741 11.4406 9.18992",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2002 11.4398C8.996 11.212 8.74771 11.0281 8.47035 10.8992C8.19299 10.7702 7.89234 10.6989 7.58661 10.6895C7.28088 10.6802 6.97644 10.733 6.69172 10.8448C6.40699 10.9565 6.14792 11.1249 5.9302 11.3398L1.4802 15.7898C0.850003 16.4215 0.496094 17.2774 0.496094 18.1698C0.496094 19.0621 0.850003 19.918 1.4802 20.5498L3.4802 22.5498C4.11195 23.18 4.96786 23.5339 5.8602 23.5339C6.75253 23.5339 7.60844 23.18 8.2402 22.5498L12.6902 18.0998C12.9063 17.8827 13.0759 17.6239 13.1885 17.339C13.3011 17.0542 13.3543 16.7494 13.3449 16.4432C13.3356 16.1371 13.2638 15.836 13.134 15.5586C13.0043 15.2812 12.8192 15.0332 12.5902 14.8298",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64062 16.3596L16.3606 7.63965",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_430_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacklink);
export default __webpack_public_path__ + "static/media/backlink.38a600e647727cfb88cfd55217bbc01e.svg";
export { ForwardRef as ReactComponent };